import * as React from 'react'
import FacetedCarousel from './FacetedCarousel/FacetedCarousel'
import SuperHero from './SuperHero/SuperHero'
import AdsCarousel from './AdsCarousel/AdsCarousel'
import BlueBar from './BlueBar'
import * as styles from './Collection.module.scss'
import * as cn from 'classnames'
import InView from 'react-intersection-observer'
import { StorefrontStateCollection, StorefrontStateItem, FeatureSwitches } from '../../containers/Storefront';
import { StorefrontCarouselEditInfo, RequestContext, Logger, safeBool } from '@utils'
import { IntermissionHero } from './IntermissionHero/IntermissionHero'

export interface CollectionProps extends StorefrontStateCollection {
  isPhablet: boolean
  collectionKey: number
  hoverClass?: string
  canLazyLoad?: boolean
  removeItem?: Function
  updateCollection?: Function
  canLivePlayback: boolean
  formFactor: string
  requestFocusForHover?: () => void
  resetFocusForHover?: () => void
  collectionHasFocusForHover?: boolean
  filterOn?: boolean
  isLast?: boolean
  featureSwitches?: FeatureSwitches
  isLoading?: boolean
  isFrozen?: boolean
  showBlueBars?: boolean
  collectionType: CollectionType
  paginationTargetId?: string
  paginationServiceToken?: string
  estimatedTotal?: number
  pageType?: string
  pageId?: string
  edit?: StorefrontCarouselEditInfo
  facetType?: string
  tags?: string[]
  context: RequestContext
  logger: Logger 
}

export type CollectionType = "TwinHero" | "SquareCarousel" | "BoxArtCarousel" | "PortraitCarousel" | "DoubleDeckerCarousel" | "SuperHero" | "Carousel" | "AdsCarousel" | "IntermissionHero"

const carouselIsRemoved = (items: StorefrontStateItem[], filterOn?: boolean) => {
  if (!filterOn)
    return false
  const hasRemainingItem = items.some((item) => {
    return safeBool(item.filterEntitled)
  })
  return !hasRemainingItem
}

const Collection = (props: CollectionProps) => {
  const { collectionType, items } = props

  switch (collectionType) {
    case 'SuperHero':
      return (
        <InView
          threshold={0.7}
        >
          {(inView) => 
            <SuperHero
              items={items.filter(item => item && item.image && item.link &&
              item.image.url && item.link.url && (!props.filterOn || item.filterEntitled))}
              webUid={props.webUid}
              modelDebug={props.modelDebug} 
              formFactor={props.formFactor}
              isFrozen={props.isFrozen || !inView}
              featureSwitches={props.featureSwitches}
            />
          }
        </InView>
      )
    case 'AdsCarousel':
      return (<AdsCarousel
        left={props.items[0]}
        right={props.items[1]}
      />)
    case 'IntermissionHero':
      return (<IntermissionHero {...props}/>)
    default:
      return (<FacetedCarousel
        {...props}
        filterOn={props.filterOn && !carouselIsRemoved(props.items, props.filterOn)}
      />)
  }
}

const BlueBarWrapper = (props: CollectionProps) => props.showBlueBars && Boolean(props.collectionMeta) &&
  (<BlueBar {...props.collectionMeta} />)

const CollectionWrapper = (props: CollectionProps) => {
  const hasItems = props && props.items && props.items.length &&
    props.items.filter(i => !i.isRemoved).length
  if (!hasItems) {
    return (<BlueBarWrapper {...props} />)
  }
  const isRemoved = carouselIsRemoved(props.items, props.filterOn)
  return (
    <div className={cn(styles.Collection, 'u-collection tst-collection',
      {
        [styles.filterLoading]: props.isLoading &&
          props.collectionType !== 'SuperHero',
        [styles.containsSuperHero]: props.collectionType === 'SuperHero',
        [styles.isRemoved]: isRemoved
      },
      { ['mobile-collection']: props.isPhablet })}>
      <BlueBarWrapper {...props} />
      <Collection {...props} />
    </div>
  )
}

export default CollectionWrapper
